module.exports = __webpack_public_path__ + "VIPH1.png?5ae25a50bfa72b9bf0083dbfc8e4fad1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH1.png
// module id = 81
// module chunks = 0